import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
    text1: string;
    text2: string;
    text3: string;
}

export const AlertPanelBasicHeader: React.FC<Props> = (
    {
        text1,
        text2,
        text3,
    }
) => {
    return (
        <DelayListHeader>
            <Text1>{text1}</Text1>
            <Text2>{text2}</Text2>
            <Text3>{text3}</Text3>
        </DelayListHeader>
    );
};

const DelayListHeader = styled.div`
  height: 44px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 33px 0 8px;
  background-color: ${theme.palette.primitives.gray50};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  width: 390px;
`;

const Text1 = styled.div`
  width: 221px;
  text-align: left;
  color: ${theme.palette.primitives.gray500};
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  box-sizing: border-box;
  margin: 8px;
`;

const Text2 = styled.div`
  width: 60px;
  color: ${theme.palette.primitives.gray400};
  font-weight: 500;
  font-size: 12px;
  text-align: left;
  box-sizing: border-box;
  font-style: normal;
  line-height: normal;
  padding: 0;
  margin: 0;
`;

const Text3 = styled.div`
  color: ${theme.palette.primitives.red500};
  width: 60px;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: right;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  right: 0;
`;
